import { isEmpty } from './../../shared/core/util';
import { Component, Input, AfterContentChecked } from '@angular/core';
import { NgForm, ControlContainer, AbstractControl } from '@angular/forms';
import {ValidationErrorType} from './password-validation-error-type';

@Component({
    selector: 'jhi-password-strength-bar',
    template: `
        <div class="row no-indent col-12" id="passwordChecks">
            <div
                id="passwordChecks-left"
                class="col-lg-6"
                [class.neutre]="!form.dirty">
                <ul>
                    <li [class.valid]="minLength">
                        Longueur minimale 12 caractères
                    </li>
                    <li [class.valid]="lowercase">
                        Contient au moins une lettre minuscule
                    </li>
                    <li [class.valid]="uppercase">
                        Contient au moins une lettre majuscule
                    </li>
                    <li [class.valid]="number">Contient au moins un chiffre</li>
                    <li [class.valid]="special">
                        Contient au moins un caractère parmi les éléments
                        suivants : ² & é ~ " # ' {{ "{" }} ( [ - | è \` _ ç ^ à
                        @ ) ] ° = {{ "}" }} + ^ ¨ $ £ ¤ % ù * µ ! § / : ; . , ?
                        < >
                    </li>
                </ul>
            </div>
        </div>
    `,
    styleUrls: ['password-strength-bar.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class PasswordStrengthBarComponent implements AfterContentChecked {
    @Input()
    passwordInputName: string;

    @Input()
    confirmPasswordName: string;

    minLength = false;
    lowercase = false;
    uppercase = false;
    number = false;
    special = false;
    confirmationValide = false;

    constructor(public form: NgForm) {}

    ngAfterContentChecked(): void {
        const passwordInput = this.form.controls[this.passwordInputName];
        this.minLength = this.hasNewValue(passwordInput) && !this.hasError(passwordInput, ValidationErrorType.MIN_LENGTH);
        this.lowercase = this.hasNewValue(passwordInput) && !this.hasError(passwordInput, ValidationErrorType.LOWERCASE);
        this.uppercase = this.hasNewValue(passwordInput) && !this.hasError(passwordInput, ValidationErrorType.UPPERCASE);
        this.number = this.hasNewValue(passwordInput) && !this.hasError(passwordInput, ValidationErrorType.NUMBER);
        this.special = this.hasNewValue(passwordInput) && !this.hasError(passwordInput, ValidationErrorType.SPECIAL);

        const confirmPassword = this.form.controls[this.confirmPasswordName];
        this.confirmationValide = confirmPassword && confirmPassword.dirty && confirmPassword.valid;
    }

    private hasError(control: AbstractControl, errorKey: string): boolean {
        return control && control.errors && control.errors[errorKey];
    }

    private hasNewValue(control: AbstractControl) {
        return control && control.dirty && !isEmpty(control.value);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password/password-strength-bar.component.ts